export default "__VITE_ASSET__Cwsi4jcD__"